// extracted by mini-css-extract-plugin
export default {"meetingLinkInfo":"MeetingLinkInfo_meetingLinkInfo__H2mNG"};